import { GenericIdName } from "../setup-implement/setup-implement.model";

export class CustomerList {
    Id: number;
    Name: string;
}
export class MakeList {
    Id: number;
    Name: string;
}
export class FamilyList {
    Id: number;
    Name: string;
}

export class ModelSelectionFilter
{
    public Families:number []
    public Makes:number []
}
export class JobsiteSelectionFilter
{
    public Customers:number []
}

export class SaveFavouritesParams {
    public FavouriteId: number;
    public FavouriteName: string;
    public DefaultView: number;
    public Customers: number[];
    public Jobsites: number[];
    public Families: number[];
    public Makes: number[];
    public Models: number[];
    public ImplementTypes:number[];
    public ImplementTypeSortOrder:GenericIdName[]
    public GETDashboardColumnsDetails:GETDashboardColumnsVM[]
   // public DashboardColumnSortOrder:GenericIdName[]
}

export class ImplementTypeSortOrder
{
        public  Id :number
        public  Name:string
        public  Position :number
}

export class FilterImplementParams{
    public  Id :number
    public  Name:string
    public  Check :boolean
}

export class ImplementSelectionFilter{
    public Equipments:number[]
    public Customers:number[]
    public Jobsites:number[]
}

export class ComponentTypeSelectionFilter{
    public Implements:number[]
}

//Digital form 

export class FilteredDigitalFormsVM{
    public FormId :number;
    public FormName:string;
    public CatId:number;
    public CatName:string;
    public LinkedModels:GenericIdName[];
    public LinkedCustomer:GenericIdName[];
    public ModelsList:string;
    public CustomerList:string;
    public Customer:string;
    public Jobsite:string;
    public Serialno:string;
    public UnitNo:string;
    public statusID:number;
    public Status:string;
    public StatusId :number;
    public UploadId :number;
    public EqCustomer :string;
    public EQJobsite :string;
    public IsStartByInspector:boolean;
    public Family :string
    public Model:string
    public CreateDate:string
    public Inspector:string
    public InspectorId:number
    public hasAttentionRequired:boolean
    public hasImmediateAction:boolean
    public hasMultipleAnswers:boolean
    public hasCommentAdded:boolean
    public IsFECRForm:boolean;
    public SMR :number;
    public SMRDiff:number;
    public AttentionRequiredCount:boolean
    public ImmediateActionCount:boolean
    public MultipleAnswersCount:boolean
    public CommentAddedCount:boolean
    public CreateDate_:Date;
    public IsStartBySupervisor:boolean;
}

export class DigitalFormData{
    DigtalFormSeachResult:DigtalFormSeachResult[];
    TotalRecords:number;
}


export class DigtalFormSeachResult{
    public AvaibleFormsList:FilteredDigitalFormsVM[];
    public CompletedForms: FilteredDigitalFormsVM[];
}

export class PerformSearchDigitalForm{
    public customer:number[];
    public jobsite:number[];
    public equipment:number[];
    public family:number[];
    public models:number[];
    public formCategory:number[];
    public forms:number[];
    public InProgress:boolean;
    public InReview:boolean;
    public Completed:boolean;
    public NotCompleted:boolean;
    public AttentionRequired:boolean;
    public ImmediateAction:boolean;
    public MultipleAnswers:boolean;
    public CommentAdded:boolean;
    public inspector:number[];
    public startDate: Date;
    public endDate: Date;
    public AllFlags:boolean;
    public sortName: string;
    public sortOrder: string;
    public PageNo: number;
    public PageSize: number;
}

export class MachineForecastInspectionVM{
    
    public jobsite:number;
    public equipment:number;
    public models:number;
    public startDate: Date;
    public endDate: Date;
    public startSMU:number;
    public endSMU:number;
    public startCMU:number;
    public endCMU:number;
    public startDistance:number;
    public endDistance:number;
    public selectedMonth:number;
    public selectedYear:number;
    public selectedComponentType:number;
    public selectedMake:number;
    public selectedSide:number;
}

export class MachineForecastInspectionSeachResult{
    public MachineInspectionList: MachineInspectionVM[]; 
    public ComponentStatisticsList: ForecastInspectionStatsResult[];
}

export class ForecastInspectionStatsResult{
    public jobsite:number;
    public models:number;
    public ComponentType :string;
    public ComponentStatisticsStatsList: ComponentStatisticsVM[];
    public HourPercentageAverage : Number;
    public DistancePercentageAverage : Number;
    public HourWearAverage : Number;
    public DistanceWearAverage : Number;
    public HourPercentageAverageRight : Number;
    public DistancePercentageAverageRight : Number;
    public HourWearAverageRight : Number;
    public DistanceWearAverageRight : Number;
    public AverageDailyHours : Number;
    public AverageDailyDistance : Number; 
}

export class ForecastInspectionAverageVM{
        public jobsite:number;
        public scenario:string;
        public modelid:number;
        public comments:string;
        public ComponentStatisticsAverageVM: ForecastInspectionStatsResult[];
}

export class MachineInspectionVM{
        public MachineInspectionId:number; 
        public ModelId :string;
        public UnitNumber :string; 
        public SerialNumber :string; 
        public SiteId :number; 
        public InspectionDate :Date;
        public SMU :number; 
        public Distance  :string;
        public AverageDailyHours  :string;
        public AverageDailyDistance  :string;
        public inspection_auto :number;
        public JobSiteName:string; 
}

export class ComponentStatisticsVM{
    public MachineInspectionId:number; 
    public track_unit_auto:string; 

    public ComponentId :number; 
    public Side :number; 
    public BrandID :number; 
    public WornPercentage:string; 
    public InspectionAuto:number;
    public StartSmu :number; 
    public ComponentDistance :string;
    public Wear:string; 
    public DistancePercentage :string;
    public HourPercentage :string;
    public DistanceWear:string; 
    public HourWear :string;
    public inspection_auto :number; 
    public ComponentType :string; 
    public BrandIDRight :number; 
    public WornPercentageRight:string; 

    public StartSmuRight :number; 
    public ComponentDistanceRight :string;
    public WearRight:string; 
    public DistancePercentageRight :string;
    public HourPercentageRight :string;
    public DistanceWearRight:string; 
    public HourWearRight :string;
}

export class  SectionQuestionsVM{
    public  DigitalForms :DigitalFormVM
    public  Questions :DigitalFormQuestionsVM[]
    public  QuestionTypes :DigitalFormQuestionTypesVM[]
    public  CategorySections:DigitalFormQuestionsCategoriesVM[];
    public  FlagTypes:FlagTypesVM[];
}

export class  DigitalFormDataVM{
    public  DigitalForms :DigitalFormVM
    public QuestionCategories :DigitalFormQuestionsCategoriesVM[]
  public Questions: DigitalFormQuestionsVM[]
  public OtherInspectionQuestions: DigitalFormQuestionsVM[]
    public  QuestionTypes :DigitalFormQuestionTypesVM[]
    public  ParentCategories :DigitalFormQuestionsCategoriesVM[]
    public  CategorySections:DigitalFormQuestionsCategoriesVM[]
    public FormStatusList :FormStatusTypesVM[];
    public FlagTypes:FlagTypesVM[];
    public LastFourInspectionQuestionAnswerVMList:LastFourInspectionQuestionAnswerVM[]
    public SMUUnitVMList:SMUUnitListVM[]
    
}

export class DigitalFormSearchVM {
  public FormId: number;
  public UploadId: number;
  public SummStartDate: Date;
  public SummEndDate: Date;
}

export class  LastFourInspectionQuestionAnswerVM{
    public  Date :string
    public  FormUploadId :string
    public  SMU :string
}
export class  SMUUnitListVM{
    public  SMU :string
}


export  class DigitalFormVM {
    public  FormId :number
    public  FormName :string
    public  FormCategoeryId:number
    public FormCategoeryName:string;
    public  Active :boolean
    public  EmailonComplete :boolean
    public customerId :number[]
    public  familyId :number[]
    public  modelId :number[]
    public  IsSafetyForm :boolean;
    public  Serial:string;
    public EquipmentId:number;
    public familyListName:string;
    public modelListName:string;
    public customerListName :string;
    public  FormStatusID :number
    public  FormStatus :string;
    public FormStartDate :string;
    public  Inspector:string;
    public RevisionNo:string;
    public EQCustomer:string;
    public EQJobsite:string;
    public Notes:string;
  public SMU: number;
  public WorkOrder: string;
    public FormStartDate_:Date
    public TemplateName:string
    public QuestionsOverAllStatus: number;
    public OverAllInprogressCount: number;
}

export class DigitalFormQuestionsCategoriesVM{
    public  QuestionCatId:number
    public  QCategoryName :string
    public  FormId :number
    public  Order :number
    public  QuestionCount :number
    public  IsParent :boolean
    public  ParentCatId :number
    public ParentCatName:string;
    public Active:boolean;
    public NotStartCount:number;
    public CompleteCount:number;
    public InProgressCount:number;
    public CatStatus:string;
    public hasFlag:boolean;
    public Questions:DigitalFormQuestionsVM[];
    public AllQuestions:DigitalFormQuestionsVM[];
    public Sections: DigitalFormQuestionsCategoriesVM[];
}

export class DigitalFormQuestionsVM{
    public  QuestionId :number;
        public  QTitle :string
        public  QDescription :string
        public  Active :boolean
        public  AllowImages :boolean
        public  AllowComments :boolean
        public  FormId:number;
        public  QuestionTypeId :number;
  public HasQuestionImage: boolean;
  public IsCat: number;
  public QuestionCatId: number;
  public QuestionCat: string;
        public  Order :number;
        public  ImageEdit :boolean
        public  QuestionTypeName :string
        public  QuestionNumber :number;

        public  QuestionImage :string
        public  ModelAnswers:ModelAnswerList[];
        public UploadImages :string[]
        public  EditedQuestionImage :string
        public UnableToComplete:boolean;
        public UploadId:number;
        public inspectorId:number;
        public InspectorName:string;
        public Flag:boolean;
        public SchematicList :SchematicListVM[];
        public ObservationDetails:ObPointMeasurementVM[];
        public QuestionFlag:number;
        public FlagColor:string;
        public ClearFlag:boolean;
        public FlagComment:string;
        public FlagClearComment:string;
        public updateFlag:boolean=false;
        public AnswerDate:string;
        public QStatus:number;
  public WorkInProgress: boolean;
  public InspectionDate: string;
  public Answer: string;
  public SMU: string;
  public InspectionStatus: string;
  public ImagesCount: number;
  public CommentsCount: number;
  public IsAnswerMandatory: boolean;
  public QuestionComment: string;
  public AnswerArray: any;
  public IsActiveLimit: boolean
}       

export class ComponentsVM{
    public  ComponentTypeId :number;
    public  ComponentTypeName :number;

    public  ComponentId :number;
    public  ComponentName :string
    public  ComponentObservationPointId :number;
    public ObservationPoint:ObservationPointVM[];
}
export class ReadingVM{
    public ReadingNum:number;
    public Measurement:number;
}

export class ObPointMeasurementVM{
    public ObPointId:number;
    public ReadingNumber:number;
    public Measurement:number;
    public Percentage:number;
    public UoM:number;
    public obsImages:string[];
    public comment:string;
    public obsUnabletoComplete:boolean;
    public obsFlagID:number;
    public obsFlagComment :string;
    public obsFlagColour:string;
    public obsClearFlag:boolean;
    public obsUpdateFlag:boolean;
    public isCrackFixed:number;
    public obsWorkInProgress:boolean;


}

export class ObservationPointVM{
    public  ObservationPointId :number;
    public  ObservationPointName :string
    public  ObservationPointPosX :number;
    public  ObservationPointPosY :number;
    public  EndObservationPointPosX :number;
    public  EndObservationPointPosY :number;
    public  schematic_auto :number;
    public  observationPointTypeId:number;
    public  numberOfReading :number;
    public selected:boolean=false;
    public pointLedgend:number;
    public obsUnabletoComplete:boolean;
    public comment:string;
    public  ObservationPointQuestionTitle :string
    public  ObservationPointQuestionInstruction :string
    public IsNew :boolean
    public isConfirm:boolean
    public isCrackFixed:boolean;
    public measurement:string;
    public measurement_:number;
    public IsAnswer:boolean;
    public IsImage:boolean;
    public obsWorkInProgress: boolean;
    public WornPct: number;
    public InspectionDate: string;
    public CrackStatusId: number;
    public ColorCode: string;
    public CrackStatus: string;
    public CurrentLength: number;
    public InstallDate: string;
    public CrackSeverity: string;
}   
export class SchematicListVM{
    public componentId:number;
    public schematic_Filename:string;
    public schematic_attachement :string;
    public schematic_auto:number;
}

export class ModelAnswerList{
        public  AnswerId :number
        public  QuestionId:number
        public  Answer :string
        public  select :boolean
        public  QuestionName :string
        public  EndWorn :any
        public Components:ComponentsVM[];
}

export class DigitalFormQuestionTypesVM{
    public Id:number;
    public Title:string;
}

export class UpdateQuestion{
    public FormId:number;
    public UploadId:number;
    public ParentCatId:number;
    public IsSupervisour:boolean;
    public Questions:DigitalFormQuestionsVM[];
}

export class FormStatusTypesVM{
    public ID:number;
    public Status:string;
}
export class FormHeaderVM{
    public Id:number;
    public standardField:number;
    public fieldname:string;
    public qid:number;
    public order:number;
    public answer:string;
}
export class FlagTypesVM{
    public ID:number;
    public Name:string;
    public Color:string;
    public CompleteColor:string;
    public EmailSend:boolean;
}

export class ClearFlagVM{
    public Id:number;
    public Comment:string;
    public FlagField:boolean;
    
}

export class QustionHistoryVM{
    public QuestionId:number;
    public QTitle:string;
    public EquipmentId:number;
    public HistoryList: QuestionHistoryInfo[];
}
export class QuestionHistoryInfo{
    public  QId :number;
    public  CompletedDate:string;
    public  FormName :string;
    public  FormId  :number;
    public  InspectorName :string;
    public  InspectorId :number;
    public  Amswers :string;
    public  FlagTypeId  :number;
    public  QuestionCommment :string;
    public  QuestionImages:string[];
    public  UploadId  :number;
    public  SectionId  :number;
    public  SelectedQuestion :boolean;
    public ObPointsInfo:ObservationMeasurementVM[]
}
export class ObservationMeasurementVM{
    public ObPointId:number;
    public ComponentName:string;
    public ObPointName:string
    public ObsReading:ObsReading[];
}
export class ObsReading{
    public ReadingNum:number;
    public Measurement:string
}

export class GETDashboardComponentHistroyInspectionVM{
    public CompId:number;
    public System:string;
    public CompName:string;
    public Date:Date;
    public InspectionSource:string;
    public QuestionName:string;
    public QId:number;
    public Worn:number;
    public CMU :number;
    public Residual:number;
    public Projected:number;
    public UploadId:number;
    public FormId:number;
    public FormName:string;
    public Answers:string;
    public CatId:number;
    public ComponentType:string;
    public QuestionType:string;
    public StartingDim:number;
    public EndingDim:number;

}

export class SerialNOSelectionFilter
{
    public Jobsites:number[]
    public Families:number[]
    public Makes:number[]
    public Models:number[]
  
}


export class AssetSerialSelectionFilter{
    public AssetSerial:number[]
}


export class ImplementSelectionFilterCrackView{
    public Equipments:number[]
    public Customers:number[]
    public Jobsites:number[]
    public ImplementTypes:number[]
    public Family:number[]
}

export class SaveFavouritesParamsDigitalForms {
    public FavouriteId: number;
    public FavouriteName: string;
    public DefaultView: number;
    public Customers: number[];
    public Jobsites: number[];
    public Families: number[];
    public Models: number[];
    public FormCategories: number[];
    public Machines: number[];
    public Inspectors: number[];
    public FormNames: number[];
    public Status: number[];
    public dateRange:number[];
    public dateRange_:number
    public isDefaultFav:boolean
}

export class  GETDashboardColumnsVM{
    public columnId:number
    public Name:string
    public ckecked:boolean
    public position:number
    public favouriteID:number
}

export class formUploadDate{
    public uploadId:number
    public startDate:Date
}


export class AdditionalComponentsVM{
    public AdditionalCompId :number;
    public AddiCompName:string
    public ModelId:number;
    public ModelName :string;
    public SystemTypeId:number;
    public System:string;
    public IsBoogie:boolean;
    public IsActive:boolean;
    public Side:boolean;
    public Image:string;
    public ModelIdList:number[];

}

export class BulkDeleteUploadForm{
    public UploadIds:number[]
}

export class InspectionEventSearchFiltersVM {
  public customers: number[];
  public jobsites: number[];
  public equipments: number[];
  public families: number[];
  public models: number[];
  
}

export class InspectionEventSearchResultVM {
  public customer: string;
  public jobsite: string;
  public equipment: string;
  public Family: string;
  public model: string;
  public unitNumber: string;
  public inspectionDate: string;
  public riskRating: string;
  public sapWorkOrder: number;
  public inspectionComments: string;
  public recommendedActions: string;
  public inspectionId: number;
  public smu: number;
  public measuredDataPer: string;
  public printPdf: string;
  public bushTurnRight:string;
  public bushTurnLeft:string;
  public customerId: number;
  public actions: string;
}
